export default __webpack_public_path__ + "images/axion-edit-profile.svg";